module.exports = __webpack_public_path__ + "static/media/featured_album.1d5af40d.jpg";